/**!
 * Apricot
 * @version 4.5.46
 * @author Mitra Assadi
 * @license
 * Copyright (c) 2024 The College Board
 */

/* ========================================================================
 * Apricot's Base
 * ======================================================================== */

// SCSS
import "../scss/includes/apricot-base.scss";

window.cb = window.cb || {};
window.cb.apricot = window.cb.apricot || {};
window.cb.apricot.version = "4.5.46";

// javaScript
export default {};
